// User roles enum
export default {
  AdminFull: 1,
  User: 2,
  Warehouse: 3,
  Technician: 4,
  Planning: 5,
  AdminData: 6,
  Inactive: 7
};

// AdminFull and AdminData are the accounting roles that assign, reopen and process incoming documents
export const isAccountingRole = (role) => Number(role) === 1 || Number(role) === 6;
